var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIcNotiError = function SvgIcNotiError(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 40 40",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M38 20c0 9.941-8.059 18-18 18S2 29.941 2 20 10.059 2 20 2s18 8.059 18 18Zm2 0c0 11.046-8.954 20-20 20S0 31.046 0 20 8.954 0 20 0s20 8.954 20 20Zm-19-8.571v11.428a1 1 0 0 1-2 0V11.43a1 1 0 0 1 2 0ZM21.143 28a1.143 1.143 0 1 1-2.286 0 1.143 1.143 0 0 1 2.286 0Z"
  })));
};
export default SvgIcNotiError;